import type { OutreachMessage } from '@discovr/types';

const CONFIDENCE_HELP: Record<string, string> = {
  token: 'Matched by the reply-to token',
  headers: 'Matched by In-Reply-To or References',
  thread: 'Matched by the Gmail thread',
  manual: 'Attached by hand',
  auto_reply_recent: 'Auto-reply matched to the latest email it echoes',
};

/** How a reply was tied to this thread, in words; undefined when it wasn't. */
export function matchConfidenceHelp(confidence: OutreachMessage['matchConfidence']): string | undefined {
  return confidence && confidence !== 'unmatched' ? CONFIDENCE_HELP[confidence] : undefined;
}
